'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmailMetadata = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _attachmentTypes = require('../constants/attachmentTypes');

var _getAttachments = require('./getAttachments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEmailMetadata = exports.getEmailMetadata = function getEmailMetadata(commonMessage) {
  var attachments = (0, _getAttachments.getAttachments)(commonMessage);
  if (attachments) {
    return attachments.find(function (attachmentObject) {
      return (0, _get2.default)(_messageTypes.MESSAGE_TYPE_ID, attachmentObject) === _attachmentTypes.EMAIL_METADATA;
    });
  }
  return undefined;
};